const ResultsDataAction  = (data)=> async dispatch=>{

    try{
        if(data!=null && data!=undefined){
            dispatch({
                type:'RESULTSDATA',
                payload:{data:data}
            })
        }
    }catch(err){
        console.log(err)
        dispatch({
            type:"FAIL"
        })
    }

}
export default ResultsDataAction;